/**
 * Custom GQL template literal tag for syntax highlighting and auto-complete of GQL operations in IDEs.
 */
export const gql = String.raw;
//# sourceMappingURL=gql.js.map